export enum ATTRIBUTES {
  MEDIA = '6673',
  VALVE_TYPE_ATTR = '7700',
  APPLICATION_TYPE = '892',
  PRODUCT_SECTION = '6084',
  PRODUCT_TYPE_ATTR = '6691',
  COMPETITOR_PRODUCT = '7614',
  FAIL_SAFE = '8160',
  RETROFIT_FAIL_SAFE = '7683',
  COMPANY_COMPETITOR = '7687',
  COMPANY_SENSOR_COMPETITOR = '8401',
  INTEGRATED_SWITCH = '112',
  INTEGRATED_SWITCH_COMPETITOR = '7684',
  PRESSURE_DEPENDENT = '8162',
  DISPLAY_TYPE = '7977',
  DISPLAY_TYPE_SAS = '592',
  TORQUE = '260',
  TORQUE_COMPETITOR_NM = '7611',
  TORQUE_COMPETITOR_INLB = '8253',
  ACTUATING_FORCE = '118',
  ACTUATING_FORCE_COMPETITOR_N = '8261',
  ACTUATING_FORCE_COMPETITOR_LBF = '8262',
}

export const INTEGRATED_SWITCH_ATTRS: string[] = [
  ATTRIBUTES.INTEGRATED_SWITCH_COMPETITOR,
  ATTRIBUTES.INTEGRATED_SWITCH,
];

export const BELIMO = 'Belimo';

export const YES = '@yes';
export const NO = '@no';

export const NULL_ARRAY_STRING = JSON.stringify(['NULL']);
